<template>
  <div class="placeOrder__component">
    <div class="finalize-jacket-sides">
      <ul class="finalize-jacket-sides__list">
        <li
          v-for="jacketSide in jacketSides"
          :key="jacketSide.jacketId"
          class="jacket-item"
        >
          <b-spinner label="Loading..." variant="primary" v-if="!imagesIsDone"/>
          <img :src="jacketSide.image" alt="" class="jacket-item__img"/>
          <h4>{{ jacketSide.side.toUpperCase() }}</h4>
        </li>
      </ul>
      <ul class="finalize-jacket-sides__svgList">
        <li v-for="(item, index) in jacketSides"
            :key="index"
            class="jacket-container"
            :class="item.side"
            :id="item.side">
          <div :id="item.jacketId">
          </div>
          <div class="sub-image-wrapper" ref="imageContainer">
            <img class="sub-image"
              :src="item.backgroundImage"
              :style="backgroundImageStyle(item)">
          </div>
        </li>
      </ul>

    </div>
    <FinalizeOrderForm :imagesIsDone="imagesIsDone" />
  </div>
</template>

<script>

import {
  JACKET_SIDES, JACKET_TYPE, COLLARS
} from '@/common/constants';
import FinalizeOrderForm from '@/components/finalizeOrder/FinalizeOrderForm.vue';
import back from '@/assets/jacket/back.svg';
import front from '@/assets/jacket/front.svg';
import left from '@/assets/jacket/left.svg';
import right from '@/assets/jacket/right.svg';

import backRaglanClassic from '@/assets/images/jacket-back-sub-raglan-classic.png';
import frontRaglanClassic from '@/assets/images/jacket-front-sub-raglan-classic.png';
import leftRaglanClassic from '@/assets/images/jacket-left-sub-raglan-classic.png';
import rightRaglanClassic from '@/assets/images/jacket-right-sub-raglan-classic.png';
import backRaglanHoodie from '@/assets/images/jacket-back-sub-raglan-hood.png';
import frontRaglanHoodie from '@/assets/images/jacket-front-sub-raglan-hood.png';
import leftRaglanHoodie from '@/assets/images/jacket-left-sub-raglan-hood.png';
import rightRaglanHoodie from '@/assets/images/jacket-right-sub-raglan-hood.png';
import backRaglanZipper from '@/assets/images/jacket-back-sub-raglan-zipper.png';
import frontRaglanZipper from '@/assets/images/jacket-front-sub-raglan-zipper.png';
import leftRaglanZipper from '@/assets/images/jacket-left-sub-raglan-zipper.png';
import rightRaglanZipper from '@/assets/images/jacket-right-sub-raglan-zipper.png';

import backSetInClassic from '@/assets/images/jacket-back-sub-setIn-classic.png';
import frontSetInClassic from '@/assets/images/jacket-front-sub-setIn-classic.png';
import leftSetInClassic from '@/assets/images/jacket-left-sub-setIn-classic.png';
import rightSetInClassic from '@/assets/images/jacket-right-sub-setIn-classic.png';
import backSetInHoodie from '@/assets/images/jacket-back-sub-setIn-hood.png';
import frontSetInHoodie from '@/assets/images/jacket-front-sub-setIn-hood.png';
import leftSetInHoodie from '@/assets/images/jacket-left-sub-setIn-hood.png';
import rightSetInHoodie from '@/assets/images/jacket-right-sub-setIn-hood.png';
import backSetInZipper from '@/assets/images/jacket-back-sub-setIn-zipper.png';
import frontSetInZipper from '@/assets/images/jacket-front-sub-setIn-zipper.png';
import leftSetInZipper from '@/assets/images/jacket-left-sub-setIn-zipper.png';
import rightSetInZipper from '@/assets/images/jacket-right-sub-setIn-zipper.png';

import * as SVG from 'svg.js/dist/svg';
import svgApi from '@/api/svgApi';
import * as htmlToImage from 'html-to-image';

export default {
  name: 'FinalizePage',
  components: {
    FinalizeOrderForm
  },
  data () {
    return {
      JACKET_SIDES,
      imagesIsDone: false,
      jacketSides: [
        {
          id: '',
          jacket: null,
          jacketId: 'front-side',
          svgId: 'jacket-front',
          jacketIsLoaded: false,
          side: JACKET_SIDES.FRONT,
          image: null,
          backgroundImage: null,
        },
        {
          id: '',
          jacket: null,
          jacketId: 'back-side',
          svgId: 'jacket-back',
          jacketIsLoaded: false,
          side: JACKET_SIDES.BACK,
          image: null,
          backgroundImage: null,
        },
        {
          id: '',
          jacket: null,
          jacketId: 'left-side',
          svgId: 'jacket-left',
          jacketIsLoaded: false,
          side: JACKET_SIDES.LEFT,
          image: null,
          backgroundImage: null,
        },
        {
          id: '',
          jacket: null,
          jacketId: 'right-side',
          svgId: 'jacket-right',
          jacketIsLoaded: false,
          side: JACKET_SIDES.RIGHT,
          image: null,
          backgroundImage: null,
        },
      ],
      canvasWidth: 816,
      canvasHeight: 492,
      JACKET_TYPE,
      COLLARS
    };
  },
  computed: {
    activeJacketType () {
      return this.$store.getters['design/getJacketType'];
    },

    activeCollarType () {
      return this.$store.getters['design/getCollarType'];
    },

    activeTrimPattern () {
      return this.$store.getters['design/getActiveTrimPattern'];
    },

    getPatchSize () {
      return (patchId) => this.$store.getters['design/getPatchSize'](patchId);
    },
    patchesBySide () {
      return (jacketSide) => this.$store.getters['design/getPatchesBySide'](jacketSide);
    },
    jacketType () {
      return this.$store.getters['design/getJacketType'];
    },
    patches () {
      return this.$store.getters['design/getProjectPatches'];
    },
    elementsColor () {
      return [
        {
          id: '#body',
          color: this.$store.getters['design/getBodyColor']
        },
        {
          id: '#sleeves',
          color: this.$store.getters['design/getSleevesColor']
        },
        {
          id: '#snaps',
          color: this.$store.getters['design/getSnapsColor']
        },
        {
          id: '#pockets',
          color: this.$store.getters['design/getPocketsColor']
        },
        {
          id: '#baseTrims',
          color: this.$store.getters['design/getBaseTrimsColor']
        },
        {
          id: '#secondaryTrims',
          color: this.$store.getters['design/getSecondaryTrimsColor']
        },
        {
          id: '#finishTrims',
          color: this.$store.getters['design/getFinishTrimsColor']
        },
        {
          id: '#insideCollar',
          color: this.$store.getters['design/getInsideCollarColor']
        },
      ];
    },
    backgroundImages () {
      let backgroundImagesBySide;

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType === COLLARS.CLASSIC) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontRaglanClassic,
          [JACKET_SIDES.BACK]: backRaglanClassic,
          [JACKET_SIDES.LEFT]: leftRaglanClassic,
          [JACKET_SIDES.RIGHT]: rightRaglanClassic,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType === COLLARS.HOODIE) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontRaglanHoodie,
          [JACKET_SIDES.BACK]: backRaglanHoodie,
          [JACKET_SIDES.LEFT]: leftRaglanHoodie,
          [JACKET_SIDES.RIGHT]: rightRaglanHoodie,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType === COLLARS.ZIPPER_HOOD) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontRaglanZipper,
          [JACKET_SIDES.BACK]: backRaglanZipper,
          [JACKET_SIDES.LEFT]: leftRaglanZipper,
          [JACKET_SIDES.RIGHT]: rightRaglanZipper,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType === COLLARS.CLASSIC) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontSetInClassic,
          [JACKET_SIDES.BACK]: backSetInClassic,
          [JACKET_SIDES.LEFT]: leftSetInClassic,
          [JACKET_SIDES.RIGHT]: rightSetInClassic,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType === COLLARS.HOODIE) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontSetInHoodie,
          [JACKET_SIDES.BACK]: backSetInHoodie,
          [JACKET_SIDES.LEFT]: leftSetInHoodie,
          [JACKET_SIDES.RIGHT]: rightSetInHoodie,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType === COLLARS.ZIPPER_HOOD) {
        backgroundImagesBySide = {
          [JACKET_SIDES.FRONT]: frontSetInZipper,
          [JACKET_SIDES.BACK]: backSetInZipper,
          [JACKET_SIDES.LEFT]: leftSetInZipper,
          [JACKET_SIDES.RIGHT]: rightSetInZipper,
        };
      }
      return backgroundImagesBySide;
    }
  },

  mounted () {
    const jacketBackgroundPromises = this.jacketSides.map((item) => {
      return this.loadBackgroundsJackets(item.side, this.backgroundImages);
    });

    this.initJacket();

    Promise.all(jacketBackgroundPromises).then(() => {
      this.loadJacket();
    });
  },
  methods: {
    backgroundImageStyle (item) {
      let subImageStyle;
      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${50.5}%`,
          width: '450px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${49.5}%`,
          width: '451px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${51.2}%`,
          width: '451px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.5}%`,
          top: `${50.5}%`,
          width: '450px',
          transform: `translate(${-49.9}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${49.5}%`,
          width: '450px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.FRONT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${51.0}%`,
          width: '451px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${50.5}%`,
          width: '450px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${48.5}%`,
          width: '462px',
          transform: `translate(${-49.9}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${50.6}%`,
          width: '451px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${50.9}%`,
          width: '450px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.6}%`,
          top: `${48.5}%`,
          width: '451px',
          transform: `translate(${-49.8}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.BACK) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.5}%`,
          top: `${50.7}%`,
          width: '454px',
          transform: `translate(${-49.8}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50}%`,
          top: `${50.5}%`,
          width: '174px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${51.2}%`,
          top: `${48.1}%`,
          width: '194px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${51}%`,
          top: `${49}%`,
          width: '191px',
          transform: `translate(${-50.5}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50.1}%`,
          top: `${50.8}%`,
          width: '175px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${51.2}%`,
          top: `${48}%`,
          width: '194px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.LEFT) {
        subImageStyle = {
          position: 'absolute',
          left: `${51}%`,
          top: `${49}%`,
          width: '191px',
          transform: `translate(${-50.5}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50}%`,
          top: `${50.5}%`,
          width: '174px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${49}%`,
          top: `${48}%`,
          width: '194px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.SET_IN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${49.2}%`,
          top: `${49}%`,
          width: '190px',
          transform: `translate(${-51}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.CLASSIC
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${50}%`,
          top: `${50.8}%`,
          width: '175px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.HOODIE
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${48.9}%`,
          top: `${48.3}%`,
          width: '194px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }

      if (this.activeJacketType === JACKET_TYPE.RAGLAN
        && this.activeCollarType.toLowerCase() === COLLARS.ZIPPER_HOOD
        && item.side === JACKET_SIDES.RIGHT) {
        subImageStyle = {
          position: 'absolute',
          left: `${49.1}%`,
          top: `${49}%`,
          width: '190px',
          transform: `translate(${-50}%, ${-50}%) scale(${2})`,
        };
      }
      return subImageStyle;
    },

    initJacket () {
      this.jacketSides.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.jacket = SVG(item.jacketId).size(this.canvasWidth, this.canvasHeight);
        // eslint-disable-next-line no-param-reassign
        item.id = item.jacket.node.id;
      });
    },

    loadJacket () {
      const svgToSide = {
        [JACKET_SIDES.FRONT]: front,
        [JACKET_SIDES.BACK]: back,
        [JACKET_SIDES.LEFT]: left,
        [JACKET_SIDES.RIGHT]: right,
      };

      const jacketPromises = this.jacketSides.map((item) => {
        const svgFile = svgToSide[item.side];
        const lastJacket = item.jacket.select(`#${item.svgId}`).last();
        if (lastJacket) {
          lastJacket.remove();
        }
        return svgApi.loadLocalSvg(svgFile)
          .then((svgText) => {
            item.jacket.svg(svgText);
            item.jacket.select('svg').last()
              .width(1100)
              .height(900)
              .id(item.svgId)
              .cx(item.jacket.cx())
              .cy(item.jacket.cy());

            this.elementsColor.forEach((element) => {
              item.jacket.select(element.id).fill(element.color.hex);
            });
            this.loadPatches(item);
            item.jacket.select(`#${this.activeTrimPattern}`).style('display', 'block');

            item.jacket.select(`#${this.activeCollarType.toLowerCase()}`).style('display', 'block');

            item.jacket.select(`#${this.activeJacketType}`).style('display', 'block');
            return true;
          })
          .then(() => this.takeScreenshot(item.side));
      });

      // all jackets are loaded
      Promise.all(jacketPromises).then(() => {
        const screenshots = {};
        const jacketSvgs = {};

        this.jacketSides.forEach((sideItem) => {
          screenshots[sideItem.side] = sideItem.image;
          jacketSvgs[sideItem.side] = sideItem.jacket.svg();
        });

        this.imagesIsDone = true;
        this.$store.dispatch('design/setScreenshots', screenshots);
        this.$store.dispatch('design/setJacketSvgs', jacketSvgs);
      });
    },

    loadPatches (item) {
      if (this.patchesBySide(item.side).ids) {
        this.patchesBySide(item.side).ids.forEach((patchId) => {
          this.addPatch(patchId, this.patchesBySide(item.side).data[patchId].options, item);
        });
      }
    },
    getJacketSvg (item) {
      return item.jacket.select(`#${item.svgId}`).last();
    },

    addPatch (patchId, options, item) {
      const patch = this.patchesBySide(item.side).data[patchId];
      item.jacket.svg(patch.svgText);
      const patchElement = item.jacket.last();

      this.initialTransformPatch(patchElement, options);
    },

    initialTransformPatch (patchElement, options = null) {
      const wrapper = patchElement.select(`#${patchElement.id()}--wrapper`).first();

      if (options) {
        if (options.isTextPatch) {
          patchElement.cx(options.cx);
          patchElement.cy(options.cy);
          wrapper.scale(options.transformData.scaleX);
          wrapper.rotate(options.transformData.rotation);
          return false;
        }

        patchElement.x(options.x);
        patchElement.y(options.y);
        if (options.transform) {
          wrapper.node.setAttribute('transform', options.transform);
        }
      }
      return true;
    },

    loadBackgroundsJackets (side, imagesObj) {
      return svgApi.loadLocalJacketBackgrounds(imagesObj[side]).then((data) => {
        this.jacketSides = this.jacketSides.map((jacketSide) => {
          if (jacketSide.side === side) {
            return {
              ...jacketSide,
              backgroundImage: data.url
            };
          }
          return jacketSide;
        });
      });
    },

    takeScreenshot (side) {
      document.getElementById(side).style.fontFamily = "'Brisen', 'Freshman', 'cloistrk', 'BrisenTail'";
      return htmlToImage
        .toPng(document.getElementById(side), { pixelRatio: 1 }).then((base64image) => {
          this.jacketSides = this.jacketSides.map((jacketSide) => {
            if (jacketSide.side === side) {
              return {
                ...jacketSide,
                image: (base64image)
              };
            }
            return jacketSide;
          });
          return true;
        });
    }
  },
};
</script>

<style scoped>
.placeOrder__component {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.finalize-jacket-sides {
  margin-bottom: 50px;
}

.finalize-jacket-sides__svgList {
  height: auto;
  display: flex;
  position: absolute;
  top: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  right: 10000px;
}

.finalize-jacket-sides__list {
  display: flex;
  margin: 0;
  padding: 0;

  .jacket-item {
    list-style: none;
    text-align: center;
    margin-left: -152px;
    margin-right: 24px;

    &__img {
      margin-bottom: 20px;
      width: 408px;
    }

    &:first-child {
      margin-left: -76px;
    }
  }
}

.jacket-container {
  position: relative;
  z-index: 1;
  width: 1630px;
  height: 984px;
}

#front-side,
#back-side,
#left-side,
#right-side {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
}

#front-side >>> {
  svg {
    -webkit-transform: translate(50%, 50%) scale(2);/* Safari and Chrome */
    -o-transform: translate(50%, 50%) scale(2);/* Opera */
    -moz-transform: translate(50%, 50%) scale(2);/* Firefox */
  }
}

#back-side >>> {
  svg {
    -webkit-transform: translate(50%, 50%) scale(2);/* Safari and Chrome */
    -o-transform: translate(50%, 50%) scale(2);/* Opera */
    -moz-transform: translate(50%, 50%) scale(2);/* Firefox */
  }
}

#left-side >>> {
  svg {
    -webkit-transform: translate(50%, 50%) scale(2);/* Safari and Chrome */
    -o-transform: translate(50%, 50%) scale(2);/* Opera */
    -moz-transform: translate(50%, 50%) scale(2);/* Firefox */
  }
}

#right-side >>> {
  svg {
    -webkit-transform: translate(50%, 50%) scale(2);/* Safari and Chrome */
    -o-transform: translate(50%, 50%) scale(2);/* Opera */
    -moz-transform: translate(50%, 50%) scale(2);/* Firefox */
  }
}

.sub-image-wrapper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.jacket-item {
  overflow: visible;
}

</style>
